import React, { useState } from 'react';
import { Button, Data, Dates, TableData, Tasks } from '../styles';
import TaskCard from '../taskCard';
import { OneWeekTaskDataInterface, TaskDetailsInterface } from '../../../interfaces/TaskInterface';

interface Props {
  item: OneWeekTaskDataInterface;
  currentMonth: Date;
  onClickTaskDetails: (item: TaskDetailsInterface) => void;
}

function TableCell(props: Props) {
  const { item, currentMonth, onClickTaskDetails } = props || {};
  //States
  const [expanded, setExpanded] = useState(false);

  const toggleExpansion = () => {
    setExpanded(!expanded);
  };

  return (
    <TableData>
      <Data>
        <Dates className='dates' disabled={new Date(item?.date).getMonth() !== currentMonth.getMonth()}>
          {new Date(item?.date)?.getDate()}
        </Dates>
        <Tasks>
          {item?.tasks?.map((task, index: number) => {
            if (index < 2)
              return (
                <React.Fragment key={task?.id}>
                  <TaskCard taskTitle={task?.name} onClickTaskDetails={() => onClickTaskDetails(task)} />
                </React.Fragment>
              );
            else return <React.Fragment key={task?.id}></React.Fragment>;
          })}
        </Tasks>
        {item?.tasks?.length > 2 && (
          <>
            {expanded ? (
              <Button onClick={toggleExpansion}>Show less</Button>
            ) : (
              <Button onClick={toggleExpansion}>{item?.tasks?.length - 2} more</Button>
            )}
            {expanded && (
              <Tasks>
                {item?.tasks?.map((task, index: number) => {
                  if (index >= 2)
                    return (
                      <React.Fragment key={task?.id}>
                        <TaskCard taskTitle={task?.name} onClickTaskDetails={() => onClickTaskDetails(task)} />
                      </React.Fragment>
                    );
                  else return <React.Fragment key={task?.id}></React.Fragment>;
                })}
              </Tasks>
            )}
          </>
        )}
      </Data>
    </TableData>
  );
}

export default TableCell;
